import { MyOrganizationsWidget } from "@/features/dashboard/components/MyOrganizationsWidget";
import { MyProfileWidget } from "@/features/dashboard/components/MyProfileWidget";
import { QuickLinksWidget } from "@/features/dashboard/components/QuickLinksWidget";
import { SimpleGrid, Stack, Title } from "@mantine/core";
import { useTranslation } from "react-i18next";

export function DashboardPage() {
  const { t } = useTranslation("dashboard");

  return (
    <Stack gap="md">
      <Title order={2}>{t("page.title")}</Title>
      <SimpleGrid cols={{ base: 1, sm: 2, lg: 4 }} spacing="md">
        <MyProfileWidget />
        <MyOrganizationsWidget />
        <QuickLinksWidget />
      </SimpleGrid>
    </Stack>
  );
}
